import {PromotionalBannerSection} from './promotional-banner-section.types'
import {ReviewSection} from './review-section.types'
import {KnowledgeSection} from './knowledge-section.type'
import {InspirationSection} from './inspiration-section.types'
import {SignupSection} from './signup-section.types'

export interface ProDirectoryPage {
  content: ProDirectoryPageContent[]
}

export type ProDirectoryPageContent =
  | PromotionalBannerSection
  | ReviewSection
  | KnowledgeSection
  | InspirationSection
  | SignupSection

export interface ProDirectorySection {
  __type: 'ProDirectorySection'
  id: string
  plot?: string
  title: string
  description?: string
  industryIds?: string[]
  offeringIds?: string[]
  location?: ProDirectorySectionLocation
}

export interface ProDirectorySectionLocation {
  zip: number
  postalDistrict: string
  distance?: ProDirectorySectionLocationDistance // distance in meter
}

export const ProDirectorySectionLocationDistanceValues = [15000, 30000, 60000, 90000] as const
export type ProDirectorySectionLocationDistance = (typeof ProDirectorySectionLocationDistanceValues)[number]
